import { render, staticRenderFns } from "./QuickConfig.vue?vue&type=template&id=98d8840c&scoped=true"
import script from "./QuickConfig.vue?vue&type=script&lang=js"
export * from "./QuickConfig.vue?vue&type=script&lang=js"
import style0 from "./QuickConfig.vue?vue&type=style&index=0&id=98d8840c&prod&lang=scss&scoped=true"
import style1 from "./QuickConfig.vue?vue&type=style&index=1&id=98d8840c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d8840c",
  null
  
)

export default component.exports